import { jsx as _jsx } from "react/jsx-runtime";
// TenantLogo.tsx
import { useEffect } from 'react';
import { useGetLogo } from 'utils';
import { defaultLogo } from '../constants';
export const TenantLogo = ({ height = '40', className }) => {
    const { data: imgSrc, execute: getLogo } = useGetLogo();
    useEffect(() => {
        getLogo();
    }, [getLogo]);
    return (_jsx("img", { alt: 'tenant-logo', className: `custom-logo ${className ? className : ''}`, src: imgSrc || defaultLogo, height: height }));
};
